import { filter, map, startWith, takeUntil } from "rxjs/operators";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { Subject } from "rxjs";

import { TranslatePipe } from "@ngx-translate/core";
import { CustomTranslateService } from "./providers/translate/services/custom-translate.service";
import { QueryParamPreserverService } from "./providers/translate/services/query-param-preserver.service";
import { AppStateService } from "./providers/store/app-state.service";
import { BrandingService } from "./modules/branding/providers/branding.service";
import { Title } from "@angular/platform-browser";
import { SentryService } from "./providers/sentry/sentry.service";
import { AccessibilityService } from "./providers/accessibility/accessibility.service";
import { VONAGE } from "./routes";
import { LoadingSpinnerComponent } from "./loading-spinner/loading-spinner.component";
import { AnalyticsComponent } from "./modules/analytics/analytics.component";
import { FooterLegalLinksComponent } from "./modules/footer-legal-links/footer-legal-links.component";
import { ModalComponent } from "./modules/modal/modal.component";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [
    RouterOutlet,
    TranslatePipe,
    LoadingSpinnerComponent,
    AnalyticsComponent,
    FooterLegalLinksComponent,
    ModalComponent
],
})
export class AppComponent implements OnInit, OnDestroy {
    showVideoConsultationLegalLinks = false;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly router: Router,
        private customTranslateService: CustomTranslateService,
        private queryParamPreserver: QueryParamPreserverService,
        private appState: AppStateService,
        private titleService: Title,
        private branding: BrandingService,
        private readonly sentryService: SentryService,
        private accessibilityService: AccessibilityService,
    ) {
        this.sentryService.init();
        this.customTranslateService.initTranslate();
        this.queryParamPreserver.init();
        this.branding.initBranding();
        this.branding
            .getBrandingSettingsFromStore()
            .pipe(filter((e) => e !== null && e !== undefined))
            .subscribe(
                (res) => {
                    if (res.title) {
                        this.titleService.setTitle(res.title);
                    }
                },
                (err) => console.log(err),
            );

        this.router.events
            .pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd),
                map(() => this.urlPathWithoutQuery(this.router.url)),
                startWith(this.urlPathWithoutQuery(this.router.url)),
                takeUntil(this.destroy$),
            )
            .subscribe((path) => {
                this.showVideoConsultationLegalLinks = path === `/${VONAGE}`;
            });
    }

    ngOnInit(): void {
        this.appState.initState();
        this.accessibilityService.setupAccessibilityFeatures();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.accessibilityService.dispose();
    }

    skipToMainContent(event: Event): void {
        this.accessibilityService.skipToMainContent(event);
    }

    private urlPathWithoutQuery(url: string): string {
        return (url.split("?")[0] ?? "").trimEnd();
    }
}
